/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_ExternalInputs */

const en_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External`)
};

const de_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern`)
};

const es_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externa`)
};

const fr_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe`)
};

const nl_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern`)
};

const pt_br2_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externa`)
};

const ro_admin_dashboard_external = /** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern`)
};

/** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */
const it_admin_dashboard_external = en_admin_dashboard_external;

/** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */
const pl_admin_dashboard_external = en_admin_dashboard_external;

/** @type {(inputs: Admin_Dashboard_ExternalInputs) => LocalizedString} */
const hu_admin_dashboard_external = en_admin_dashboard_external;

/**
* | output |
* | --- |
* | "External" |
*
* @param {Admin_Dashboard_ExternalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_external = /** @type {((inputs?: Admin_Dashboard_ExternalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_ExternalInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_external(inputs)
	if (locale === "de") return de_admin_dashboard_external(inputs)
	if (locale === "es") return es_admin_dashboard_external(inputs)
	if (locale === "fr") return fr_admin_dashboard_external(inputs)
	if (locale === "nl") return nl_admin_dashboard_external(inputs)
	if (locale === "it") return it_admin_dashboard_external(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_external(inputs)
	if (locale === "pl") return pl_admin_dashboard_external(inputs)
	if (locale === "hu") return hu_admin_dashboard_external(inputs)
	return ro_admin_dashboard_external(inputs)
});
export { admin_dashboard_external as "admin.dashboard.external" }